const BASE_URL = import.meta.env.VITE_API_URL || '/api'

function getToken() {
  return localStorage.getItem('dinner_token')
}

async function request(method, path, body = null, params = null) {
  const token = getToken()
  const headers = { 'Content-Type': 'application/json' }
  if (token) headers['Authorization'] = `Bearer ${token}`

  let url = `${BASE_URL}${path}`
  if (params) {
    const qs = new URLSearchParams(params).toString()
    url += `?${qs}`
  }

  const res = await fetch(url, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined
  })

  const data = await res.json()
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`)
  return data
}

export const api = {
  get: (path, params) => request('GET', path, null, params),
  post: (path, body) => request('POST', path, body),
  delete: (path) => request('DELETE', path),

  // Auth
  passkeyAuthOptions: (userId) => request('POST', '/auth/passkey/auth-options', { userId }),
  passkeyAuthVerify: (challengeKey, authResponse) => request('POST', '/auth/passkey/auth-verify', { challengeKey, authenticationResponse: authResponse }),
  passkeyRegisterOptions: () => request('POST', '/auth/passkey/register-options', {}),
  passkeyRegisterVerify: (regResponse) => request('POST', '/auth/passkey/register-verify', { registrationResponse: regResponse }),
  passwordLogin: (userId, password) => request('POST', '/auth/login', { userId, password }),

  // Meals
  listMeals: () => request('GET', '/meals'),
  createMeal: (meal) => request('POST', '/meals', meal),
  deleteMeal: (mealId) => request('DELETE', `/meals/${mealId}`),
  updateMeal: (mealId, updates) => request('PUT', `/meals/${mealId}`, updates),
  recipeSearch: (query, index = 0) => request('POST', '/meals/recipe-search', { query, index }),

  // Restaurants
  searchRestaurants: (query, lat, lng) => request('GET', '/restaurants/search', null, { query, lat, lng }),

  // Calendar
  getWeek: (start, end) => request('GET', '/calendar', null, { start, end }),
  proposeMeal: (date, mealId, dayNotes) => request('POST', `/calendar/${date}/propose`, { mealId, dayNotes }),
  agreeMeal: (date) => request('POST', `/calendar/${date}/agree`, {}),
  withdrawMeal: (date) => request('DELETE', `/calendar/${date}`),

  // Pinterest
  pinterestBoards: () => request('GET', '/pinterest/boards'),
  pinterestPins: (boardId, bookmark = null) => request('GET', '/pinterest/pins', null, bookmark ? { boardId, bookmark } : { boardId }),
}
